import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { Nullable } from 'cng-common/models/utils'
import { IReportPeriod } from 'partner360/models/report/iReportPeriod'
import { IQuarterlyMarketTableRow } from 'partner360/models/report/sobAnalyticsReports/iQuarterlyMarketTableRow'
import { IQuarterlyPartnerTableRow } from 'partner360/models/report/sobAnalyticsReports/iQuarterlyPartnerTableRow'

import { exportReportsPptx } from '../../api'
import {
  mapQuarterlyCollectedData,
  mapQuarterlyMarketData,
  mapQuarterlyPartnerData,
} from '../../lib/mappers/quarterly'

interface IExportPptxData {
  fileParams: {
    baseName?: string
    category?: string
  }
  reportTitle: string
  view?: IReportPeriod
  category?: string
  rtm: string
  fYear: number
  netNdp: string
  quarterMarketData: IQuarterlyMarketTableRow[]
  quarterMarketTotalData: Nullable<IQuarterlyMarketTableRow>
  quarterPartnerData: IQuarterlyPartnerTableRow[]
  isExpectedExit: boolean
}

export const exportReportsPptxThunk = createAsyncThunk(
  'reports/exportReportsPptx',
  async (data: IExportPptxData) => {
    await exportReportsPptx(
      {
        title: data.reportTitle,
        fYear: data.fYear,
        rtm: data.rtm,
        netNdp: data.netNdp,
        quarterlyView: {
          title: 'Quarterly View',
          period: data.view?.Title || '-',
          marketData: mapQuarterlyMarketData(data.quarterMarketData),
          totalData: data.quarterMarketTotalData
            ? mapQuarterlyMarketData([data.quarterMarketTotalData])
            : [],
          collectedData: mapQuarterlyCollectedData(data.quarterMarketTotalData),
          partnerData: mapQuarterlyPartnerData(data.quarterPartnerData),
          isExpectedExit: data.isExpectedExit,
        },
      },
      data.fileParams
    )
  }
)
